import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import Logo from "./util/Logo";
import DashboardIcon from '@material-ui/icons/Dashboard';
import LogoutButton from "./util/LogoutButton";
import GroupIcon from '@material-ui/icons/Group';
import {useNavigate} from "react-router-dom";
import SchoolIcon from '@material-ui/icons/School';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import PieChartIcon from '@material-ui/icons/PieChart';
import {ListSubheader} from "@material-ui/core";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AuthService from "../services/AuthService";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
        background: '#f5f5f5',
        color: '#000000'
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
        background: '#fdfdfd',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    title: {
        flexGrow: 1,
    },
    selected: {
        color: theme.palette.primary.main,
        fontWeight: 'bold'
    }
}));

export const ListItems = {
    overview: 'Overview',
    individual: 'My Team',
    learningPlans: 'Learning Plans',
    learningLibrary: 'Team Library',
    skills: 'Skills'
}

const authService = AuthService()
const reload = () => {
    window.location.reload();
}

function ResponsiveDrawer({window, children, surveyId, activeItem}) {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const navigateToUrl = (basePath) => {
        if (surveyId) {
            navigate('/' + basePath + '/' + surveyId)
        }
    }

    const drawer = (
        <div>
            <div className={classes.toolbar} style={{margin: 'auto'}} ><Logo/></div>
            <List>
                <ListItem button onClick={() => navigateToUrl('overview')}>
                    <ListItemIcon><PieChartIcon color={activeItem === ListItems.overview ? 'primary' : 'inherit'} /></ListItemIcon>
                    <ListItemText className={activeItem === ListItems.overview ? classes.selected : ''} primary={ListItems.overview} />
                </ListItem>
                <ListItem button onClick={() => navigateToUrl('skills')}>
                    <ListItemIcon><DashboardIcon color={activeItem === ListItems.skills ? 'primary' : 'inherit'} /></ListItemIcon>
                    <ListItemText className={activeItem === ListItems.skills ? classes.selected : ''} primary={ListItems.skills} />
                </ListItem>
                <ListItem button onClick={() => navigateToUrl('individual')}>
                    <ListItemIcon><GroupIcon color={activeItem === ListItems.individual ? 'primary' : 'inherit'} /></ListItemIcon>
                    <ListItemText className={activeItem === ListItems.individual ? classes.selected : ''} primary={ListItems.individual} />
                </ListItem>
                {/*<ListItem button onClick={() => navigateToUrl('learning-plans')}>*/}
                {/*    <ListItemIcon><SchoolIcon color={activeItem === ListItems.learningPlans ? 'primary' : 'default'} /></ListItemIcon>*/}
                {/*    <ListItemText className={activeItem === ListItems.learningPlans ? classes.selected : ''} primary={ListItems.learningPlans} />*/}
                {/*</ListItem>*/}
                {/*<ListItem button onClick={() => navigateToUrl('learning-library')}>*/}
                {/*    <ListItemIcon><LocalLibraryIcon color={activeItem === ListItems.learningLibrary ? 'primary' : 'inherit'} /></ListItemIcon>*/}
                {/*    <ListItemText className={activeItem === ListItems.learningLibrary ? classes.selected : ''} primary={ListItems.learningLibrary} />*/}
                {/*</ListItem>*/}
                <Divider/>
                <ListSubheader>Operations</ListSubheader>
                <ListItem button onClick={() => {
                    authService.logout()
                    reload()
                }}>
                    <ListItemIcon><ExitToAppIcon /></ListItemIcon>
                    <ListItemText primary={"Logout"} />
                </ListItem>
            </List>
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Hidden smUp implementation="css">
                <AppBar position="absolute" className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            className={classes.menuButton}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" noWrap className={classes.title}>
                            {activeItem}
                        </Typography>
                        <LogoutButton/>
                    </Toolbar>
                </AppBar>
            </Hidden>
            <nav className={classes.drawer} aria-label="mailbox folders">
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Hidden smUp implementation="css">
                    <Drawer
                        container={container}
                        variant="temporary"
                        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        variant="permanent"
                        open
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
            </nav>
            <main className={classes.content}>
                {/*<div className={classes.toolbar} />*/}
                {/*{children}*/}
                <Hidden smUp implementation="js">
                    <div className={classes.toolbar} />
                    {children}
                </Hidden>
                <Hidden xsDown implementation="js">
                    {children}
                </Hidden>
            </main>
        </div>
    );
}

export default ResponsiveDrawer;
